import { useTranslation } from "react-i18next";
import { HomeTwinCtas } from "./home-twin-ctas";

export function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="relative z-10 border-b border-border-soft px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-[calc(1.85rem+1vw)] font-semibold leading-tight tracking-tight text-ink">
          {t("home.finalCta.headline")}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-pretty text-[calc(1rem+0.12vw)] font-normal leading-relaxed text-ink-secondary">
          {t("home.finalCta.sub")}
        </p>
        <HomeTwinCtas className="mt-10" />
        <p className="mx-auto mt-6 max-w-md font-mono text-[0.65rem] leading-relaxed text-ink-tertiary">
          {t("cta.finalMicro")}
        </p>
      </div>
    </section>
  );
}
